(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/util.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/util.js');
"use strict";

const formatDate = (day, month, year) => "".concat(year, "-").concat(month < 10 ? '0' : '').concat(month, "-").concat(day < 10 ? '0' : '').concat(day);
const isNextYear = (day, month) => formatDate(day, month, new Date(Date.now()).getFullYear()) < svs.utils.date.SimpleDate(new Date(Date.now()));
svs.tickets_giftshop.gift.giftform.date_selector.components.util = {
  mapMonthByNumber: month => ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'][month - 1],
  getMonth: date => parseInt(date === null || date === void 0 ? void 0 : date.split('-')[1], 10) || new Date().getMonth(),
  getYear: date => parseInt(date === null || date === void 0 ? void 0 : date.split('-')[0], 10) || new Date().getFullYear(),
  isLeapYear: year => new Date(year, 1, 29).getDate() === 29,
  aggregateDateData: function (dateData) {
    let whitelist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return Object.keys(dateData).reduce((list, month) => {
      Object.keys(dateData[month]).forEach(day => {
        let names = dateData[month][day];
        if (whitelist.length) {
          names = names.filter(name => whitelist.includes(name));
        }
        if (!names.length) {
          return;
        }
        list.push({
          date: "".concat(month, "-").concat(day),
          names: Object.values(dateData[month][day])
        });
      });
      return list;
    }, []);
  },
  sortDateData: function () {
    let dateData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return dateData.sort((a, b) => {
      const thisYear = new Date(Date.now()).getFullYear();
      const [month, day] = a.date.split('-');
      const date = new Date(isNextYear(day, month) ? thisYear + 1 : thisYear, month - 1, day, 12);
      const [nextMonth, nextDay] = b.date.split('-');
      const nextDate = new Date(isNextYear(nextDay, nextMonth) ? thisYear + 1 : thisYear, nextMonth - 1, nextDay, 12);
      return date - nextDate;
    });
  },
  isNextYear,
  formatDate
};

 })(window);